export enum CustomerContractNotificationRuleType {
  ONCE = 'ONCE',
  PERIODIC = 'PERIODIC'
}

export enum CustomerContractNotificationRuleAction {
    MAIL = 'MAIL',
}

export interface ICustomerContractNotificationRuleInDTO {
  id: number;
  customerContractId: number;
  customerContractName: string;
  customerContractServiceIds?: number[];
  customerContractServiceCodes?: string[];
  ruleType: CustomerContractNotificationRuleType;
  action: CustomerContractNotificationRuleAction;
  intervalMonths?: number;
  dayOfMonth?: number;
  specificDate?: number;
  nextFireDate?: number;
  enabled: boolean;
  emails: string[];
  startDate: number;
} 